const timezone = [
	{
	    "name": "Africa/Abidjan",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Accra",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Addis_Ababa",
	    "offset": "+03:00"
	},
	{
	    "name": "Africa/Algiers",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Asmara",
	    "offset": "+03:00"
	},
	{
	    "name": "Africa/Asmera",
	    "offset": "+03:00"
	},
	{
	    "name": "Africa/Bamako",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Bangui",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Banjul",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Bissau",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Blantyre",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Brazzaville",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Bujumbura",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Cairo",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Casablanca",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Ceuta",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Conakry",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Dakar",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Dar_es_Salaam",
	    "offset": "+03:00"
	},
	{
	    "name": "Africa/Djibouti",
	    "offset": "+03:00"
	},
	{
	    "name": "Africa/Douala",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/El_Aaiun",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Freetown",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Gaborone",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Harare",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Johannesburg",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Juba",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Kampala",
	    "offset": "+03:00"
	},
	{
	    "name": "Africa/Khartoum",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Kigali",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Kinshasa",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Lagos",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Libreville",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Lome",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Luanda",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Lubumbashi",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Lusaka",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Malabo",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Maputo",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Maseru",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Mbabane",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Mogadishu",
	    "offset": "+03:00"
	},
	{
	    "name": "Africa/Monrovia",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Nairobi",
	    "offset": "+03:00"
	},
	{
	    "name": "Africa/Ndjamena",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Niamey",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Nouakchott",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Ouagadougou",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Porto-Novo",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Sao_Tome",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Timbuktu",
	    "offset": "+00:00"
	},
	{
	    "name": "Africa/Tripoli",
	    "offset": "+02:00"
	},
	{
	    "name": "Africa/Tunis",
	    "offset": "+01:00"
	},
	{
	    "name": "Africa/Windhoek",
	    "offset": "+02:00"
	},
	{
	    "name": "America/Adak",
	    "offset": "-10:00"
	},
	{
	    "name": "America/Anchorage",
	    "offset": "-09:00"
	},
	{
	    "name": "America/Anguilla",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Antigua",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Araguaina",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Buenos_Aires",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Catamarca",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/ComodRivadavia",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Cordoba",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Jujuy",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/La_Rioja",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Mendoza",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Rio_Gallegos",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Salta",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/San_Juan",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/San_Luis",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Tucuman",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Argentina/Ushuaia",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Aruba",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Asuncion",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Atikokan",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Atka",
	    "offset": "-10:00"
	},
	{
	    "name": "America/Bahia",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Bahia_Banderas",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Barbados",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Belem",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Belize",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Blanc-Sablon",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Boa_Vista",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Bogota",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Boise",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Buenos_Aires",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Cambridge_Bay",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Campo_Grande",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Cancun",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Caracas",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Catamarca",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Cayenne",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Cayman",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Chicago",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Chihuahua",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Coral_Harbour",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Cordoba",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Costa_Rica",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Creston",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Cuiaba",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Curacao",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Danmarkshavn",
	    "offset": "+00:00"
	},
	{
	    "name": "America/Dawson",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Dawson_Creek",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Denver",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Detroit",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Dominica",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Edmonton",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Eirunepe",
	    "offset": "-05:00"
	},
	{
	    "name": "America/El_Salvador",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Ensenada",
	    "offset": "-08:00"
	},
	{
	    "name": "America/Fort_Nelson",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Fort_Wayne",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Fortaleza",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Glace_Bay",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Godthab",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Goose_Bay",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Grand_Turk",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Grenada",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Guadeloupe",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Guatemala",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Guayaquil",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Guyana",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Halifax",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Havana",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Hermosillo",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Indiana/Indianapolis",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Indiana/Knox",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Indiana/Marengo",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Indiana/Petersburg",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Indiana/Tell_City",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Indiana/Vevay",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Indiana/Vincennes",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Indiana/Winamac",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Indianapolis",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Inuvik",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Iqaluit",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Jamaica",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Jujuy",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Juneau",
	    "offset": "-09:00"
	},
	{
	    "name": "America/Kentucky/Louisville",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Kentucky/Monticello",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Knox_IN",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Kralendijk",
	    "offset": "-04:00"
	},
	{
	    "name": "America/La_Paz",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Lima",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Los_Angeles",
	    "offset": "-08:00"
	},
	{
	    "name": "America/Louisville",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Lower_Princes",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Maceio",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Managua",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Manaus",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Marigot",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Martinique",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Matamoros",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Mazatlan",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Mendoza",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Menominee",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Merida",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Metlakatla",
	    "offset": "-09:00"
	},
	{
	    "name": "America/Mexico_City",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Miquelon",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Moncton",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Monterrey",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Montevideo",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Montreal",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Montserrat",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Nassau",
	    "offset": "-05:00"
	},
	{
	    "name": "America/New_York",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Nipigon",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Nome",
	    "offset": "-09:00"
	},
	{
	    "name": "America/Noronha",
	    "offset": "-02:00"
	},
	{
	    "name": "America/North_Dakota/Beulah",
	    "offset": "-06:00"
	},
	{
	    "name": "America/North_Dakota/Center",
	    "offset": "-06:00"
	},
	{
	    "name": "America/North_Dakota/New_Salem",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Nuuk",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Ojinaga",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Panama",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Pangnirtung",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Paramaribo",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Phoenix",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Port-au-Prince",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Port_of_Spain",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Porto_Acre",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Porto_Velho",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Puerto_Rico",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Punta_Arenas",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Rainy_River",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Rankin_Inlet",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Recife",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Regina",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Resolute",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Rio_Branco",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Rosario",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Santa_Isabel",
	    "offset": "-08:00"
	},
	{
	    "name": "America/Santarem",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Santiago",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Santo_Domingo",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Sao_Paulo",
	    "offset": "-03:00"
	},
	{
	    "name": "America/Scoresbysund",
	    "offset": "-01:00"
	},
	{
	    "name": "America/Shiprock",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Sitka",
	    "offset": "-09:00"
	},
	{
	    "name": "America/St_Barthelemy",
	    "offset": "-04:00"
	},
	{
	    "name": "America/St_Johns",
	    "offset": "-03:30"
	},
	{
	    "name": "America/St_Kitts",
	    "offset": "-04:00"
	},
	{
	    "name": "America/St_Lucia",
	    "offset": "-04:00"
	},
	{
	    "name": "America/St_Thomas",
	    "offset": "-04:00"
	},
	{
	    "name": "America/St_Vincent",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Swift_Current",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Tegucigalpa",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Thule",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Thunder_Bay",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Tijuana",
	    "offset": "-08:00"
	},
	{
	    "name": "America/Toronto",
	    "offset": "-05:00"
	},
	{
	    "name": "America/Tortola",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Vancouver",
	    "offset": "-08:00"
	},
	{
	    "name": "America/Virgin",
	    "offset": "-04:00"
	},
	{
	    "name": "America/Whitehorse",
	    "offset": "-07:00"
	},
	{
	    "name": "America/Winnipeg",
	    "offset": "-06:00"
	},
	{
	    "name": "America/Yakutat",
	    "offset": "-09:00"
	},
	{
	    "name": "America/Yellowknife",
	    "offset": "-07:00"
	},
	{
	    "name": "Antarctica/Casey",
	    "offset": "+11:00"
	},
	{
	    "name": "Antarctica/Davis",
	    "offset": "+07:00"
	},
	{
	    "name": "Antarctica/DumontDUrville",
	    "offset": "+10:00"
	},
	{
	    "name": "Antarctica/Macquarie",
	    "offset": "+11:00"
	},
	{
	    "name": "Antarctica/Mawson",
	    "offset": "+05:00"
	},
	{
	    "name": "Antarctica/McMurdo",
	    "offset": "+13:00"
	},
	{
	    "name": "Antarctica/Palmer",
	    "offset": "-03:00"
	},
	{
	    "name": "Antarctica/Rothera",
	    "offset": "-03:00"
	},
	{
	    "name": "Antarctica/South_Pole",
	    "offset": "+13:00"
	},
	{
	    "name": "Antarctica/Syowa",
	    "offset": "+03:00"
	},
	{
	    "name": "Antarctica/Troll",
	    "offset": "+00:00"
	},
	{
	    "name": "Antarctica/Vostok",
	    "offset": "+06:00"
	},
	{
	    "name": "Arctic/Longyearbyen",
	    "offset": "+01:00"
	},
	{
	    "name": "Asia/Aden",
	    "offset": "+03:00"
	},
	{
	    "name": "Asia/Almaty",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Amman",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Anadyr",
	    "offset": "+12:00"
	},
	{
	    "name": "Asia/Aqtau",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Aqtobe",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Ashgabat",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Ashkhabad",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Atyrau",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Baghdad",
	    "offset": "+03:00"
	},
	{
	    "name": "Asia/Bahrain",
	    "offset": "+03:00"
	},
	{
	    "name": "Asia/Baku",
	    "offset": "+04:00"
	},
	{
	    "name": "Asia/Bangkok",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Barnaul",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Beirut",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Bishkek",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Brunei",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Calcutta",
	    "offset": "+05:30"
	},
	{
	    "name": "Asia/Chita",
	    "offset": "+09:00"
	},
	{
	    "name": "Asia/Choibalsan",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Chongqing",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Chungking",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Colombo",
	    "offset": "+05:30"
	},
	{
	    "name": "Asia/Dacca",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Damascus",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Dhaka",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Dili",
	    "offset": "+09:00"
	},
	{
	    "name": "Asia/Dubai",
	    "offset": "+04:00"
	},
	{
	    "name": "Asia/Dushanbe",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Famagusta",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Gaza",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Harbin",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Hebron",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Ho_Chi_Minh",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Hong_Kong",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Hovd",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Irkutsk",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Istanbul",
	    "offset": "+03:00"
	},
	{
	    "name": "Asia/Jakarta",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Jayapura",
	    "offset": "+09:00"
	},
	{
	    "name": "Asia/Jerusalem",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Kabul",
	    "offset": "+04:30"
	},
	{
	    "name": "Asia/Kamchatka",
	    "offset": "+12:00"
	},
	{
	    "name": "Asia/Karachi",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Kashgar",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Kathmandu",
	    "offset": "+05:45"
	},
	{
	    "name": "Asia/Katmandu",
	    "offset": "+05:45"
	},
	{
	    "name": "Asia/Khandyga",
	    "offset": "+09:00"
	},
	{
	    "name": "Asia/Kolkata",
	    "offset": "+05:30"
	},
	{
	    "name": "Asia/Krasnoyarsk",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Kuala_Lumpur",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Kuching",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Kuwait",
	    "offset": "+03:00"
	},
	{
	    "name": "Asia/Macao",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Macau",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Magadan",
	    "offset": "+11:00"
	},
	{
	    "name": "Asia/Makassar",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Manila",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Muscat",
	    "offset": "+04:00"
	},
	{
	    "name": "Asia/Nicosia",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Novokuznetsk",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Novosibirsk",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Omsk",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Oral",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Phnom_Penh",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Pontianak",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Pyongyang",
	    "offset": "+09:00"
	},
	{
	    "name": "Asia/Qatar",
	    "offset": "+03:00"
	},
	{
	    "name": "Asia/Qostanay",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Qyzylorda",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Rangoon",
	    "offset": "+06:30"
	},
	{
	    "name": "Asia/Riyadh",
	    "offset": "+03:00"
	},
	{
	    "name": "Asia/Saigon",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Sakhalin",
	    "offset": "+11:00"
	},
	{
	    "name": "Asia/Samarkand",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Seoul",
	    "offset": "+09:00"
	},
	{
	    "name": "Asia/Shanghai",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Singapore",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Srednekolymsk",
	    "offset": "+11:00"
	},
	{
	    "name": "Asia/Taipei",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Tashkent",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Tbilisi",
	    "offset": "+04:00"
	},
	{
	    "name": "Asia/Tehran",
	    "offset": "+03:30"
	},
	{
	    "name": "Asia/Tel_Aviv",
	    "offset": "+02:00"
	},
	{
	    "name": "Asia/Thimbu",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Thimphu",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Tokyo",
	    "offset": "+09:00"
	},
	{
	    "name": "Asia/Tomsk",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Ujung_Pandang",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Ulaanbaatar",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Ulan_Bator",
	    "offset": "+08:00"
	},
	{
	    "name": "Asia/Urumqi",
	    "offset": "+06:00"
	},
	{
	    "name": "Asia/Ust-Nera",
	    "offset": "+10:00"
	},
	{
	    "name": "Asia/Vientiane",
	    "offset": "+07:00"
	},
	{
	    "name": "Asia/Vladivostok",
	    "offset": "+10:00"
	},
	{
	    "name": "Asia/Yakutsk",
	    "offset": "+09:00"
	},
	{
	    "name": "Asia/Yangon",
	    "offset": "+06:30"
	},
	{
	    "name": "Asia/Yekaterinburg",
	    "offset": "+05:00"
	},
	{
	    "name": "Asia/Yerevan",
	    "offset": "+04:00"
	},
	{
	    "name": "Atlantic/Azores",
	    "offset": "-01:00"
	},
	{
	    "name": "Atlantic/Bermuda",
	    "offset": "-04:00"
	},
	{
	    "name": "Atlantic/Canary",
	    "offset": "+00:00"
	},
	{
	    "name": "Atlantic/Cape_Verde",
	    "offset": "-01:00"
	},
	{
	    "name": "Atlantic/Faeroe",
	    "offset": "+00:00"
	},
	{
	    "name": "Atlantic/Faroe",
	    "offset": "+00:00"
	},
	{
	    "name": "Atlantic/Jan_Mayen",
	    "offset": "+01:00"
	},
	{
	    "name": "Atlantic/Madeira",
	    "offset": "+00:00"
	},
	{
	    "name": "Atlantic/Reykjavik",
	    "offset": "+00:00"
	},
	{
	    "name": "Atlantic/South_Georgia",
	    "offset": "-02:00"
	},
	{
	    "name": "Atlantic/St_Helena",
	    "offset": "+00:00"
	},
	{
	    "name": "Atlantic/Stanley",
	    "offset": "-03:00"
	},
	{
	    "name": "Australia/ACT",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/Adelaide",
	    "offset": "+10:30"
	},
	{
	    "name": "Australia/Brisbane",
	    "offset": "+10:00"
	},
	{
	    "name": "Australia/Broken_Hill",
	    "offset": "+10:30"
	},
	{
	    "name": "Australia/Canberra",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/Currie",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/Darwin",
	    "offset": "+09:30"
	},
	{
	    "name": "Australia/Eucla",
	    "offset": "+08:45"
	},
	{
	    "name": "Australia/Hobart",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/LHI",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/Lindeman",
	    "offset": "+10:00"
	},
	{
	    "name": "Australia/Lord_Howe",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/Melbourne",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/NSW",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/North",
	    "offset": "+09:30"
	},
	{
	    "name": "Australia/Perth",
	    "offset": "+08:00"
	},
	{
	    "name": "Australia/Queensland",
	    "offset": "+10:00"
	},
	{
	    "name": "Australia/South",
	    "offset": "+10:30"
	},
	{
	    "name": "Australia/Sydney",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/Tasmania",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/Victoria",
	    "offset": "+11:00"
	},
	{
	    "name": "Australia/West",
	    "offset": "+08:00"
	},
	{
	    "name": "Australia/Yancowinna",
	    "offset": "+10:30"
	},
	{
	    "name": "Brazil/Acre",
	    "offset": "-05:00"
	},
	{
	    "name": "Brazil/DeNoronha",
	    "offset": "-02:00"
	},
	{
	    "name": "Brazil/East",
	    "offset": "-03:00"
	},
	{
	    "name": "Brazil/West",
	    "offset": "-04:00"
	},
	{
	    "name": "CET",
	    "offset": "+01:00"
	},
	{
	    "name": "CST6CDT",
	    "offset": "-06:00"
	},
	{
	    "name": "Canada/Atlantic",
	    "offset": "-04:00"
	},
	{
	    "name": "Canada/Central",
	    "offset": "-06:00"
	},
	{
	    "name": "Canada/Eastern",
	    "offset": "-05:00"
	},
	{
	    "name": "Canada/Mountain",
	    "offset": "-07:00"
	},
	{
	    "name": "Canada/Newfoundland",
	    "offset": "-03:30"
	},
	{
	    "name": "Canada/Pacific",
	    "offset": "-08:00"
	},
	{
	    "name": "Canada/Saskatchewan",
	    "offset": "-06:00"
	},
	{
	    "name": "Canada/Yukon",
	    "offset": "-07:00"
	},
	{
	    "name": "Chile/Continental",
	    "offset": "-03:00"
	},
	{
	    "name": "Chile/EasterIsland",
	    "offset": "-05:00"
	},
	{
	    "name": "Cuba",
	    "offset": "-05:00"
	},
	{
	    "name": "EET",
	    "offset": "+02:00"
	},
	{
	    "name": "EST",
	    "offset": "-05:00"
	},
	{
	    "name": "EST5EDT",
	    "offset": "-05:00"
	},
	{
	    "name": "Egypt",
	    "offset": "+02:00"
	},
	{
	    "name": "Eire",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/GMT",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/GMT+0",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/GMT+1",
	    "offset": "-01:00"
	},
	{
	    "name": "Etc/GMT+10",
	    "offset": "-10:00"
	},
	{
	    "name": "Etc/GMT+11",
	    "offset": "-11:00"
	},
	{
	    "name": "Etc/GMT+12",
	    "offset": "-12:00"
	},
	{
	    "name": "Etc/GMT+2",
	    "offset": "-02:00"
	},
	{
	    "name": "Etc/GMT+3",
	    "offset": "-03:00"
	},
	{
	    "name": "Etc/GMT+4",
	    "offset": "-04:00"
	},
	{
	    "name": "Etc/GMT+5",
	    "offset": "-05:00"
	},
	{
	    "name": "Etc/GMT+6",
	    "offset": "-06:00"
	},
	{
	    "name": "Etc/GMT+7",
	    "offset": "-07:00"
	},
	{
	    "name": "Etc/GMT+8",
	    "offset": "-08:00"
	},
	{
	    "name": "Etc/GMT+9",
	    "offset": "-09:00"
	},
	{
	    "name": "Etc/GMT-0",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/GMT-1",
	    "offset": "+01:00"
	},
	{
	    "name": "Etc/GMT-10",
	    "offset": "+10:00"
	},
	{
	    "name": "Etc/GMT-11",
	    "offset": "+11:00"
	},
	{
	    "name": "Etc/GMT-12",
	    "offset": "+12:00"
	},
	{
	    "name": "Etc/GMT-13",
	    "offset": "+13:00"
	},
	{
	    "name": "Etc/GMT-14",
	    "offset": "+14:00"
	},
	{
	    "name": "Etc/GMT-2",
	    "offset": "+02:00"
	},
	{
	    "name": "Etc/GMT-3",
	    "offset": "+03:00"
	},
	{
	    "name": "Etc/GMT-4",
	    "offset": "+04:00"
	},
	{
	    "name": "Etc/GMT-5",
	    "offset": "+05:00"
	},
	{
	    "name": "Etc/GMT-6",
	    "offset": "+06:00"
	},
	{
	    "name": "Etc/GMT-7",
	    "offset": "+07:00"
	},
	{
	    "name": "Etc/GMT-8",
	    "offset": "+08:00"
	},
	{
	    "name": "Etc/GMT-9",
	    "offset": "+09:00"
	},
	{
	    "name": "Etc/GMT0",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/Greenwich",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/UCT",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/UTC",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/Universal",
	    "offset": "+00:00"
	},
	{
	    "name": "Etc/Zulu",
	    "offset": "+00:00"
	},
	{
	    "name": "Europe/Amsterdam",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Andorra",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Astrakhan",
	    "offset": "+04:00"
	},
	{
	    "name": "Europe/Athens",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Belfast",
	    "offset": "+00:00"
	},
	{
	    "name": "Europe/Belgrade",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Berlin",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Bratislava",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Brussels",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Bucharest",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Budapest",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Busingen",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Chisinau",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Copenhagen",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Dublin",
	    "offset": "+00:00"
	},
	{
	    "name": "Europe/Gibraltar",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Guernsey",
	    "offset": "+00:00"
	},
	{
	    "name": "Europe/Helsinki",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Isle_of_Man",
	    "offset": "+00:00"
	},
	{
	    "name": "Europe/Istanbul",
	    "offset": "+03:00"
	},
	{
	    "name": "Europe/Jersey",
	    "offset": "+00:00"
	},
	{
	    "name": "Europe/Kaliningrad",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Kiev",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Kirov",
	    "offset": "+03:00"
	},
	{
	    "name": "Europe/Lisbon",
	    "offset": "+00:00"
	},
	{
	    "name": "Europe/Ljubljana",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/London",
	    "offset": "+00:00"
	},
	{
	    "name": "Europe/Luxembourg",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Madrid",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Malta",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Mariehamn",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Minsk",
	    "offset": "+03:00"
	},
	{
	    "name": "Europe/Monaco",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Moscow",
	    "offset": "+03:00"
	},
	{
	    "name": "Europe/Nicosia",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Oslo",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Paris",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Podgorica",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Prague",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Riga",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Rome",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Samara",
	    "offset": "+04:00"
	},
	{
	    "name": "Europe/San_Marino",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Sarajevo",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Saratov",
	    "offset": "+04:00"
	},
	{
	    "name": "Europe/Simferopol",
	    "offset": "+03:00"
	},
	{
	    "name": "Europe/Skopje",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Sofia",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Stockholm",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Tallinn",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Tirane",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Tiraspol",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Ulyanovsk",
	    "offset": "+04:00"
	},
	{
	    "name": "Europe/Uzhgorod",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Vaduz",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Vatican",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Vienna",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Vilnius",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Volgograd",
	    "offset": "+03:00"
	},
	{
	    "name": "Europe/Warsaw",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Zagreb",
	    "offset": "+01:00"
	},
	{
	    "name": "Europe/Zaporozhye",
	    "offset": "+02:00"
	},
	{
	    "name": "Europe/Zurich",
	    "offset": "+01:00"
	},
	{
	    "name": "GB",
	    "offset": "+00:00"
	},
	{
	    "name": "GB-Eire",
	    "offset": "+00:00"
	},
	{
	    "name": "GMT",
	    "offset": "+00:00"
	},
	{
	    "name": "GMT+0",
	    "offset": "+00:00"
	},
	{
	    "name": "GMT-0",
	    "offset": "+00:00"
	},
	{
	    "name": "GMT0",
	    "offset": "+00:00"
	},
	{
	    "name": "Greenwich",
	    "offset": "+00:00"
	},
	{
	    "name": "HST",
	    "offset": "-10:00"
	},
	{
	    "name": "Hongkong",
	    "offset": "+08:00"
	},
	{
	    "name": "Iceland",
	    "offset": "+00:00"
	},
	{
	    "name": "Indian/Antananarivo",
	    "offset": "+03:00"
	},
	{
	    "name": "Indian/Chagos",
	    "offset": "+06:00"
	},
	{
	    "name": "Indian/Christmas",
	    "offset": "+07:00"
	},
	{
	    "name": "Indian/Cocos",
	    "offset": "+06:30"
	},
	{
	    "name": "Indian/Comoro",
	    "offset": "+03:00"
	},
	{
	    "name": "Indian/Kerguelen",
	    "offset": "+05:00"
	},
	{
	    "name": "Indian/Mahe",
	    "offset": "+04:00"
	},
	{
	    "name": "Indian/Maldives",
	    "offset": "+05:00"
	},
	{
	    "name": "Indian/Mauritius",
	    "offset": "+04:00"
	},
	{
	    "name": "Indian/Mayotte",
	    "offset": "+03:00"
	},
	{
	    "name": "Indian/Reunion",
	    "offset": "+04:00"
	},
	{
	    "name": "Iran",
	    "offset": "+03:30"
	},
	{
	    "name": "Israel",
	    "offset": "+02:00"
	},
	{
	    "name": "Jamaica",
	    "offset": "-05:00"
	},
	{
	    "name": "Japan",
	    "offset": "+09:00"
	},
	{
	    "name": "Kwajalein",
	    "offset": "+12:00"
	},
	{
	    "name": "Libya",
	    "offset": "+02:00"
	},
	{
	    "name": "MET",
	    "offset": "+01:00"
	},
	{
	    "name": "MST",
	    "offset": "-07:00"
	},
	{
	    "name": "MST7MDT",
	    "offset": "-07:00"
	},
	{
	    "name": "Mexico/BajaNorte",
	    "offset": "-08:00"
	},
	{
	    "name": "Mexico/BajaSur",
	    "offset": "-07:00"
	},
	{
	    "name": "Mexico/General",
	    "offset": "-06:00"
	},
	{
	    "name": "NZ",
	    "offset": "+13:00"
	},
	{
	    "name": "NZ-CHAT",
	    "offset": "+13:45"
	},
	{
	    "name": "Navajo",
	    "offset": "-07:00"
	},
	{
	    "name": "PRC",
	    "offset": "+08:00"
	},
	{
	    "name": "PST8PDT",
	    "offset": "-08:00"
	},
	{
	    "name": "Pacific/Apia",
	    "offset": "+14:00"
	},
	{
	    "name": "Pacific/Auckland",
	    "offset": "+13:00"
	},
	{
	    "name": "Pacific/Bougainville",
	    "offset": "+11:00"
	},
	{
	    "name": "Pacific/Chatham",
	    "offset": "+13:45"
	},
	{
	    "name": "Pacific/Chuuk",
	    "offset": "+10:00"
	},
	{
	    "name": "Pacific/Easter",
	    "offset": "-05:00"
	},
	{
	    "name": "Pacific/Efate",
	    "offset": "+11:00"
	},
	{
	    "name": "Pacific/Enderbury",
	    "offset": "+13:00"
	},
	{
	    "name": "Pacific/Fakaofo",
	    "offset": "+13:00"
	},
	{
	    "name": "Pacific/Fiji",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Funafuti",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Galapagos",
	    "offset": "-06:00"
	},
	{
	    "name": "Pacific/Gambier",
	    "offset": "-09:00"
	},
	{
	    "name": "Pacific/Guadalcanal",
	    "offset": "+11:00"
	},
	{
	    "name": "Pacific/Guam",
	    "offset": "+10:00"
	},
	{
	    "name": "Pacific/Honolulu",
	    "offset": "-10:00"
	},
	{
	    "name": "Pacific/Johnston",
	    "offset": "-10:00"
	},
	{
	    "name": "Pacific/Kiritimati",
	    "offset": "+14:00"
	},
	{
	    "name": "Pacific/Kosrae",
	    "offset": "+11:00"
	},
	{
	    "name": "Pacific/Kwajalein",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Majuro",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Marquesas",
	    "offset": "-09:30"
	},
	{
	    "name": "Pacific/Midway",
	    "offset": "-11:00"
	},
	{
	    "name": "Pacific/Nauru",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Niue",
	    "offset": "-11:00"
	},
	{
	    "name": "Pacific/Norfolk",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Noumea",
	    "offset": "+11:00"
	},
	{
	    "name": "Pacific/Pago_Pago",
	    "offset": "-11:00"
	},
	{
	    "name": "Pacific/Palau",
	    "offset": "+09:00"
	},
	{
	    "name": "Pacific/Pitcairn",
	    "offset": "-08:00"
	},
	{
	    "name": "Pacific/Pohnpei",
	    "offset": "+11:00"
	},
	{
	    "name": "Pacific/Ponape",
	    "offset": "+11:00"
	},
	{
	    "name": "Pacific/Port_Moresby",
	    "offset": "+10:00"
	},
	{
	    "name": "Pacific/Rarotonga",
	    "offset": "-10:00"
	},
	{
	    "name": "Pacific/Saipan",
	    "offset": "+10:00"
	},
	{
	    "name": "Pacific/Samoa",
	    "offset": "-11:00"
	},
	{
	    "name": "Pacific/Tahiti",
	    "offset": "-10:00"
	},
	{
	    "name": "Pacific/Tarawa",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Tongatapu",
	    "offset": "+13:00"
	},
	{
	    "name": "Pacific/Truk",
	    "offset": "+10:00"
	},
	{
	    "name": "Pacific/Wake",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Wallis",
	    "offset": "+12:00"
	},
	{
	    "name": "Pacific/Yap",
	    "offset": "+10:00"
	},
	{
	    "name": "Poland",
	    "offset": "+01:00"
	},
	{
	    "name": "Portugal",
	    "offset": "+00:00"
	},
	{
	    "name": "ROC",
	    "offset": "+08:00"
	},
	{
	    "name": "ROK",
	    "offset": "+09:00"
	},
	{
	    "name": "Singapore",
	    "offset": "+08:00"
	},
	{
	    "name": "Turkey",
	    "offset": "+03:00"
	},
	{
	    "name": "UCT",
	    "offset": "+00:00"
	},
	{
	    "name": "US/Alaska",
	    "offset": "-09:00"
	},
	{
	    "name": "US/Aleutian",
	    "offset": "-10:00"
	},
	{
	    "name": "US/Arizona",
	    "offset": "-07:00"
	},
	{
	    "name": "US/Central",
	    "offset": "-06:00"
	},
	{
	    "name": "US/East-Indiana",
	    "offset": "-05:00"
	},
	{
	    "name": "US/Eastern",
	    "offset": "-05:00"
	},
	{
	    "name": "US/Hawaii",
	    "offset": "-10:00"
	},
	{
	    "name": "US/Indiana-Starke",
	    "offset": "-06:00"
	},
	{
	    "name": "US/Michigan",
	    "offset": "-05:00"
	},
	{
	    "name": "US/Mountain",
	    "offset": "-07:00"
	},
	{
	    "name": "US/Pacific",
	    "offset": "-08:00"
	},
	{
	    "name": "US/Samoa",
	    "offset": "-11:00"
	},
	{
	    "name": "UTC",
	    "offset": "+00:00"
	},
	{
	    "name": "Universal",
	    "offset": "+00:00"
	},
	{
	    "name": "W-SU",
	    "offset": "+03:00"
	},
	{
	    "name": "WET",
	    "offset": "+00:00"
	},
	{
	    "name": "Zulu",
	    "offset": "+00:00"
	}
]
export default timezone;


// WEBPACK FOOTER //
// ./src/data/timezone.js